export default __webpack_public_path__ + "static/media/Rooktalon Bolts.6412d9e7.jpg";